import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
const BASE_URL = process.env.REACT_APP_API_URL;
const SalesData = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const agentId = query.get('agentId');
  const month = parseInt(query.get('month'));
  const year = parseInt(query.get('year'));
  const agentName = query.get('agentName');  

  const [sales, setSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortAsc, setSortAsc] = useState(true);

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const gmSalesRes = await axios.get(`${BASE_URL}/api/gmsales?id=${agentId}`);
        const mobSalesRes = await axios.get(`${BASE_URL}/api/mobilitysales?id=${agentId}`);

        const gmData = gmSalesRes.data.map(s => ({
          Order_Number: s.Order_Number,
          SEGMENT: s.SEGMENT,
          GM_Sale_Date: s.GM_Sale_Date,
          STATUS: s.STATUS_ENG_DESC,
          Activation_Date: s.Activation_Date,
        }));

        const mobData = mobSalesRes.data.map(m => ({
          Order_Number: m.Order_Number,
          SEGMENT: 'MOB',
          GM_Sale_Date: m.GM_Sale_Date,
          STATUS: 'N/A',
          Activation_Date: ''
        }));

        const combined = [...gmData, ...mobData];

        const filtered = combined.filter(order => {
          const date = new Date(order.GM_Sale_Date);
          return !isNaN(date) && date.getUTCMonth() === month && date.getUTCFullYear() === year;
        });

        setSales(filtered);
      } catch (err) {
        console.error('Error fetching sales data:', err);
      }
    };

    if (agentId && !isNaN(month)) {
      fetchSales();
    }
  }, [agentId, month, year]);

  const filteredSales = sales
    .filter(order => order.Order_Number.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      const dateA = new Date(a.GM_Sale_Date);
      const dateB = new Date(b.GM_Sale_Date);
      return sortAsc ? dateA - dateB : dateB - dateA;
    });

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-white px-6 py-10">
      <div className="max-w-6xl mx-auto bg-white/5 border border-white/10 rounded-xl shadow-xl p-6">
        <h1 className="text-3xl font-bold mb-6 text-center">📊 Sales Data for Agent {agentId}</h1>
        <div className="flex justify-between items-center mb-4">
          <input
            type="text"
            placeholder="Search by Order Number"
            className="p-2 rounded bg-slate-800 text-white border border-gray-600"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            onClick={() => setSortAsc(!sortAsc)}
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded text-white font-semibold"
          >
            Sort by Date ({sortAsc ? 'Asc' : 'Desc'})
          </button>
        </div>

        {filteredSales.length === 0 ? (
          <p className="text-center text-gray-400">No sales records found for this month.</p>
        ) : (
          <div className="overflow-auto">
            <table className="min-w-full divide-y divide-gray-600 text-sm">
              <thead className="bg-slate-800 text-gray-300">
                <tr>
                  <th className="px-4 py-3 text-left">Order Number</th>
                  <th className="px-4 py-3 text-left">Segment</th>
                  <th className="px-4 py-3 text-left">Sale Date</th>
                  <th className="px-4 py-3 text-left">Status</th>
                  <th className="px-4 py-3 text-left">Activation Date</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {filteredSales.map((order, idx) => (
                  <tr key={`${order.Order_Number}-${idx}`} className="hover:bg-slate-800">
                    <td className="px-4 py-2">{order.Order_Number}</td>
                    <td className="px-4 py-2">{order.SEGMENT}</td>
                    <td className="px-4 py-2">
                      {order.GM_Sale_Date ? new Date(order.GM_Sale_Date).toLocaleDateString() : ''}
                    </td>
                    <td className="px-4 py-2">{order.STATUS}</td>
                    <td className="px-4 py-2">
                      {order.Activation_Date ? new Date(order.Activation_Date).toLocaleDateString() : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesData;
